// extracted by mini-css-extract-plugin
export var valueSphere = "Value-module--valueSphere--IfHCI";
export var valueSphereLine = "Value-module--valueSphereLine--DNl5Y";
export var fadeUp = "Value-module--fade-up--VNMXV";
export var easeInLine = "Value-module--ease-in-line--xp6hV";
export var valueFlame = "Value-module--valueFlame--lJ4Yp";